import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const getSubjectDisplayLabel = ({
  displayLabel,
  slug,
}: {
  displayLabel?: string;
  slug?: string;
}) => {
  if (displayLabel) {
    return displayLabel;
  }

  switch (slug) {
    case "art":
      return i18n.t("subjects.art.label", { ns: COMMON_NS });
    case "computing":
      return i18n.t("subjects.computing.label", { ns: COMMON_NS });
    case "design-tech":
      return i18n.t("subjects.design-tech.label", { ns: COMMON_NS });
    case "english":
      return i18n.t("subjects.english.label", { ns: COMMON_NS });
    case "geography":
      return i18n.t("subjects.geography.label", { ns: COMMON_NS });
    case "french":
      return i18n.t("subjects.french.label", { ns: COMMON_NS });
    case "history":
      return i18n.t("subjects.history.label", { ns: COMMON_NS });
    case "mathematics":
      return i18n.t("subjects.maths.label", { ns: COMMON_NS });
    case "music":
      return i18n.t("subjects.music.label", { ns: COMMON_NS });
    case "physical-education":
      return i18n.t("subjects.physical-education.label", { ns: COMMON_NS });
    case "pshe":
      return i18n.t("subjects.pshe.label", { ns: COMMON_NS });
    case "religion-worldviews":
      return i18n.t("subjects.religion-worldviews.label", { ns: COMMON_NS });
    case "science":
      return i18n.t("subjects.science.label", { ns: COMMON_NS });
    case "spanish":
      return i18n.t("subjects.spanish.label", { ns: COMMON_NS });
    case "spelling":
      return i18n.t("subjects.spelling.label", { ns: COMMON_NS });
    case "handwriting":
      return i18n.t("subjects.handwriting.label", { ns: COMMON_NS });
    default:
      return i18n.t("subjects.not-found.label", {
        slug: slug,
        ns: COMMON_NS,
      });
  }
};
